angular.module('ecrd').constant('ViewModes', {
    EDIT: 'edit',
    REVISION: 'revision',
});
